import { inject, injectable } from "tsyringe";
import { DataWarehouseSender } from "./data-warehouse-sender";
import { DataWarehouseParams, IdentityEventParams } from "./types";
import { dataWarehouseUrls } from "./data-warehouse-urls";

@injectable()
export class IdentityEventSender {
  constructor(
    @inject(DataWarehouseSender) private readonly sender: DataWarehouseSender,
  ) {}

  send(additionalParams: IdentityEventParams): void {
    const params = {
      ...additionalParams,
      ...this.sender.getTimeBasedParams(),
      ...this.sender.getTrackingParams(),
    } as DataWarehouseParams;

    this.sender.sendEvent(params, dataWarehouseUrls.identityinfo);
  }
}
